import {
  defaultDirection,
  defaultLocale,
  defaultColor,
  localeOptions,
  themeColorStorageKey,
  themeRadiusStorageKey,
} from '../constants/defaultValues';

export const zfill = (number, width) => {
  const numberOutput = Math.abs(number);
  const numberString = number.toString();
  const zero = '0';
  if (width <= numberString.length) {
    if (number < 0) {
      return '-'.concat(numberOutput.toString());
    }
    return numberOutput.toString();
  }
  if (number < 0) {
    return '-'.concat(
      zero.repeat(width - numberString.length),
      numberOutput.toString()
    );
  }
  return zero.repeat(width - numberString.length) + numberOutput.toString();
};

export const mapOrder = (array, order, key) => {
  array.sort(function (a, b) {
    const A = a[key];
    const B = b[key];
    if (order.indexOf(`${A}`) > order.indexOf(`${B}`)) {
      return 1;
    }
    return -1;
  });
  return array;
};

export const getDateWithFormat = () => {
  const today = new Date();
  let dd = today.getDate();
  let mm = today.getMonth() + 1; // January is 0!

  const yyyy = today.getFullYear();
  if (dd < 10) {
    dd = `0${dd}`;
  }
  if (mm < 10) {
    mm = `0${mm}`;
  }
  return `${dd}.${mm}.${yyyy}`;
};

export const getCurrentTime = () => {
  const now = new Date();
  return `${now.getHours()}:${now.getMinutes()}`;
};

export const getDirection = () => {
  let direction = defaultDirection;

  try {
    if (localStorage.getItem('direction')) {
      const localValue = localStorage.getItem('direction');
      if (localValue === 'rtl' || localValue === 'ltr') {
        direction = localValue;
      }
    }
  } catch (error) {
    console.log('>>>>: src/helpers/Utils.js : getDirection -> error', error);
    direction = defaultDirection;
  }
  return {
    direction,
    isRtl: direction === 'rtl',
  };
};
export const setDirection = (localValue) => {
  let direction = 'ltr';
  if (localValue === 'rtl' || localValue === 'ltr') {
    direction = localValue;
  }
  try {
    localStorage.setItem('direction', direction);
  } catch (error) {
    console.log('>>>>: src/helpers/Utils.js : setDirection -> error', error);
  }
};

export const getCurrentColor = () => {
  let currentColor = defaultColor;
  try {
    if (localStorage.getItem(themeColorStorageKey)) {
      currentColor = localStorage.getItem(themeColorStorageKey);
    }
  } catch (error) {
    console.log('>>>>: src/helpers/Utils.js : getCurrentColor -> error', error);
    currentColor = defaultColor;
  }
  return currentColor;
};

export const setCurrentColor = (color) => {
  try {
    localStorage.setItem(themeColorStorageKey, color);
  } catch (error) {
    console.log('>>>>: src/helpers/Utils.js : setCurrentColor -> error', error);
  }
};

export const getCurrentRadius = () => {
  let currentRadius = 'rounded';
  try {
    if (localStorage.getItem(themeRadiusStorageKey)) {
      currentRadius = localStorage.getItem(themeRadiusStorageKey);
    }
  } catch (error) {
    console.log(
      '>>>>: src/helpers/Utils.js : getCurrentRadius -> error',
      error
    );
    currentRadius = 'rounded';
  }
  return currentRadius;
};
export const setCurrentRadius = (radius) => {
  try {
    localStorage.setItem(themeRadiusStorageKey, radius);
  } catch (error) {
    console.log(
      '>>>>: src/helpers/Utils.js : setCurrentRadius -> error',
      error
    );
  }
};

export const getCurrentLanguage = () => {
  let language = defaultLocale;
  try {
    language =
      localStorage.getItem('currentLanguage') &&
      localeOptions.filter(
        (x) => x.id === localStorage.getItem('currentLanguage')
      ).length > 0
        ? localStorage.getItem('currentLanguage')
        : defaultLocale;
  } catch (error) {
    console.log(
      '>>>>: src/helpers/Utils.js : getCurrentLanguage -> error',
      error
    );
    language = defaultLocale;
  }
  return language;
};
export const setCurrentLanguage = (locale) => {
  try {
    localStorage.setItem('currentLanguage', locale);
  } catch (error) {
    console.log(
      '>>>>: src/helpers/Utils.js : setCurrentLanguage -> error',
      error
    );
  }
};

export const getCurrentUser = () => {
  let user = null;
  try {
    user =
      localStorage.getItem('gogo_current_user') != null
        ? JSON.parse(localStorage.getItem('gogo_current_user'))
        : null;
  } catch (error) {
    console.log('>>>>: src/helpers/Utils.js  : getCurrentUser -> error', error);
    user = null;
  }
  return user;
};

export const setCurrentUser = (user) => {
  try {
    if (user) {
      localStorage.setItem('gogo_current_user', JSON.stringify(user));
    } else {
      localStorage.removeItem('gogo_current_user');
    }
  } catch (error) {
    console.log('>>>>: src/helpers/Utils.js : setCurrentUser -> error', error);
  }
};
export function b64EncodeUnicode(str) {
  // first we use encodeURIComponent to get percent-encoded UTF-8,
  // then we convert the percent encodings into raw bytes which
  // can be fed into btoa.
  if (str) {
    return btoa(
      encodeURIComponent(str).replace(
        /%([0-9A-F]{2})/g,
        function toSolidBytes(match, p1) {
          return String.fromCharCode(`0x${p1}`);
        }
      )
    );
  }
  return str;
}

export function b64DecodeUnicode(str) {
  try {
    if (str) {
      // Going backwards: from bytestream, to percent-encoding, to original string.
      return decodeURIComponent(
        atob(str)
          .split('')
          .map(function (c) {
            return `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`;
          })
          .join('')
      );
    }
  } catch (e) {
    console.log(e);
  }
  return str;
}
/**
 * retorna string para ser remitido por url
 * @param {JSON} params
 * @returns {String}
 */
export const generateParametersToUrl = (params) => {
  let str = '';
  Object.entries(params).forEach((e) => {
    if (e[1] !== undefined) {
      str = str.concat('&', e[0], '=', e[1]);
    }
  });
  return str;
};
export const getStringDate = (dateTime = new Date()) => {
  const anio = dateTime.getFullYear();
  const mes = dateTime.getMonth() + 1;
  const dia = dateTime.getDate();
  const horas = dateTime.getHours();
  const minutos = dateTime.getMinutes();
  const segundos = dateTime.getSeconds();
  return `${anio}-${zfill(mes, 2)}-${zfill(dia, 2)} ${zfill(horas, 2)}:${zfill(
    minutos,
    2
  )}:${zfill(segundos, 2)}`;
};

export const parseDateString = (strDate) => {
  if (strDate) {
    if (strDate.split(' ').length > 1) {
      const date = strDate.split(' ')[0];
      const hours = strDate.split(' ')[1];
      const yr1 = parseInt(date.split('-')[0], 10);
      const mon1 = parseInt(date.split('-')[1], 10);
      const dt1 = parseInt(date.split('-')[2], 10);
      const h = parseInt(hours.split(':')[0], 10);
      const m = parseInt(hours.split(':')[1], 10);
      const s = parseInt(hours.split(':')[2], 10);
      return new Date(yr1, mon1 - 1, dt1, h, m, s);
    }
    if (strDate.split('/').length > 1) {
      const date = strDate.split('/');
      const dt1 = parseInt(date[0], 10);
      const mon1 = parseInt(date[1], 10);
      const yr1 = parseInt(date[2], 10);
      return new Date(yr1, mon1 - 1, dt1, 0, 0, 0);
    }
  }
  return new Date();
};
/**
 * devolver el mensaje que retorna del servidor
 * @param {*} objMsg
 * @returns
 */
export const getMessage = (objMsg) => {
  if (objMsg) {
    if (objMsg.msg !== undefined) {
      return objMsg.msg;
    }
    if (objMsg.message !== undefined) {
      return objMsg.message;
    }
  }
  return JSON.stringify(objMsg);
};
